export const usageActionTypes = {
    STORE_CUSTOMER_USAGE: 'STORE_CUSTOMER_USAGE',
    CLEAR_CUSTOMER_USAGE: 'CLEAR_CUSTOMER_USAGE',
} as const;
